import React, { useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { push } from "connected-react-router";
import Page from "../../components/Page";
import FileUploadEditorForm from "../../components/FileUploadEditorForm";
import { getFormValues } from "redux-form";
import EditorFormHelpers from "../../components/FileUploadEditorForm/utils/FileUploadEditorFormHelpers";
import { COLORS, COLORTYPES } from "../../utils/colors";
import { isServer } from "../../redux/store";
import { showArtwork } from "../../redux/cop/artworks";
import { useSsrEffect } from "@issr/core";

const FileUploadEditor = (props, context) => {
  const dispatch = useDispatch();

  const presetFromUrl = new URLSearchParams(props.location.search);

  const artworkId = presetFromUrl.get("artwork");
  const projectId = presetFromUrl.get("project");

  const frontload = async () => {
    if (artworkId) dispatch(showArtwork(artworkId));
  };

  useSsrEffect(frontload, [artworkId, projectId]);

  const language = useSelector((state) => state.i18nState.lang);

  const initialColor = COLORS[COLORTYPES.MATT][0];

  const smallDevice = !isServer
    ? window.matchMedia("(max-width: 767px)").matches
    : false;

  const dataLayer = [
    {
      event: "view_item",
      value: 100,
      items: [
        { id: "sticker-vehicle-motif", google_business_vertical: "retail" },
        {
          id: "sticker-vehicle-own-design",
          google_business_vertical: "retail",
        },
        { id: "window-film-design", google_business_vertical: "retail" },
        { id: "folienzuschnitt", google_business_vertical: "retail" },
        { id: "3001", google_business_vertical: "retail" },
        { id: "3002", google_business_vertical: "retail" },
        { id: "sticker-own-logo", google_business_vertical: "retail" },
        { id: "logo-shop-window", google_business_vertical: "retail" },
        { id: "individual-vinyl-print", google_business_vertical: "retail" },
        {
          id: "individual-vinyl-print-premium",
          google_business_vertical: "retail",
        },
      ],
    },
  ];

  const presetAmount =
    presetFromUrl.get("product") &&
    [18, 19, 20].includes(parseInt(presetFromUrl.get("product")))
      ? 50
      : 1;

  const presetCutting =
    presetFromUrl.get("product") &&
    [2].includes(parseInt(presetFromUrl.get("product")))
      ? "exempted"
      : presetFromUrl.get("cutting") || "rectangular";

  return (
    <Page
      id="fileuploadeditor"
      title={context.t("Stickers with Custom Design")}
      lang={language}
      dataLayer={dataLayer}
      pageType="fileeditor"
      description={context.t("File Upload Page Description")}
      image="https://cdn.myfolie.de/media/banner/800x500.png"
    >
      <FileUploadEditorForm
        initialValues={{
          editorType:
            presetFromUrl.get("product") &&
            parseInt(presetFromUrl.get("product")) > 0 &&
            parseInt(presetFromUrl.get("product")) < 29
              ? parseInt(presetFromUrl.get("product"))
              : 1,
          laminate: presetFromUrl.get("laminate") || "glossy",
          artworkId: artworkId,
          cutting: presetCutting,
          whiteprint_mode: "white_ink_underlay",
          materialSerie: presetFromUrl.get("material") || 1,
          color: { value: initialColor, label: initialColor.title },
          amount: presetFromUrl.get("amount")
            ? parseInt(presetFromUrl.get("amount"))
            : presetAmount,
          preopenSizeSelection:
            presetFromUrl.get("preopenSizeSelection") || false,
          border: 0,
          filecheck: presetFromUrl.get("skipdc") ? "no-filecheck" : "filecheck",
          isSizePresetted:
            presetFromUrl.get("width") || presetFromUrl.get("height")
              ? true
              : false,
          height: parseInt(presetFromUrl.get("height")) || 50,
          width: parseInt(presetFromUrl.get("width")) || 50,
          keepRatio: false,
          skip_file_upload: smallDevice ? true : false,
          fileRatio:
            (parseInt(presetFromUrl.get("height")) || 50) /
            (parseInt(presetFromUrl.get("width")) || 50),
          sku: false,
          vectorizeFile: false,
        }}
        language={language}
      />
    </Page>
  );
};

FileUploadEditor.contextTypes = {
  t: PropTypes.func,
};

export default FileUploadEditor;
